import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_SINGLE_COUPON,
    GET_ALL_USED_COUPONS,
    GET_ALL_COUPONS,
} from './couponTypes'
export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_COUPONS:
            return {
                ...state,
                search_allcoupons: action.payload,
            }
        case GET_SINGLE_COUPON:
            return {
                ...state,
                search_single_coupon: action.payload,
            }
        case GET_ALL_USED_COUPONS:
            return {
                ...state,
                search_allused_coupons: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
